import {
    Chip,
    alpha,
    styled
} from '@mui/material';

export const CountChip = styled(Chip)(({ theme }) => ({
  height: 20,
  minWidth: 28,
  fontSize: '0.6875rem',
  fontWeight: 700,
  borderRadius: 10,
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  color: theme.palette.primary.main,
}));

export const CloneChip = styled(Chip)(({ theme }) => ({
  height: 16,
  fontSize: '0.6rem',
  fontWeight: 700,
  backgroundColor: alpha(theme.palette.warning.main, 0.14),
  color: theme.palette.warning.dark,
  '& .MuiChip-label': { paddingLeft: 6, paddingRight: 6 },
}));